export default __webpack_public_path__ + "static/media/steam.de7d8153.svg";